module.exports = __webpack_public_path__ + "static/media/workbg-focus.51833ec3.jpg";